import axios from 'axios';
import { API_CONFIG, LANGUAGE } from '../constant';
import { v4 as uuidv4 } from 'uuid';
import { logout } from '../storage/tokenState';
import { trackApiCall, handle401Error } from '../hooks/useAutoLogout';

export const getDeviceId = (): string => {
  let deviceID = localStorage.getItem('deviceID');
  if (!deviceID) {
    deviceID = uuidv4();
    localStorage.setItem('deviceID', deviceID);
  }
  return deviceID;
};

export const baseAxiosWithToken = (token: string) =>{

   return axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        }
    });

}
export const baseAxiosWithoutToken = () =>{

  return axios.create({
       baseURL: process.env.REACT_APP_API_URL,
       headers: {
           'Content-Type': 'application/json',
       }
   });

}


export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    version: process.env.REACT_APP_VERSION,
    appversion: process.env.REACT_APP_VERSION,
   // Platform: 'android',
    appname: process.env.REACT_APP_APP_NAME || 'pwa.verticalbyzupee.com',
    language: localStorage.getItem("language") || LANGUAGE,
    'Package-Name': process.env.REACT_APP_APPPACKAGENAME || 'pwa.verticalbyzupee.com',
    isPwa: true,
    deviceID: getDeviceId(),
  },
  timeout: API_CONFIG.REFERRAL_CALL_TIMEOUT,
});


export const getCommonApiWithToken = async (url: string, token: string, extraHeaders: any = {}) => {
  // Track API call - this prevents inactivity timer from resetting
  trackApiCall();
  try {
      const response = await baseAxiosWithToken(token).get(url, { headers: extraHeaders });
      if(response?.data?.response?.success === false){
        console.log("server error:", response?.data?.response?.error);
        throw new Error(response?.data?.response?.error);
      }
      return response.data;
    } catch (error) {
      // Optional: Extract more detailed server error message


      if (axios.isAxiosError(error)) {

        if(error.response?.status === 401){
          // Immediate logout on 401 error
          handle401Error();
          return Promise.reject(error);
        }

        const message =
          error.response?.data?.message ||
          `Server responded with status ${error.response?.status}` ||
          'Unknown error';
        throw new Error(message);
      }
      throw new Error("We’re having trouble connecting to the server. Please try again in a moment.");
    }
  };

  export const getCommonApiWithTokenPostMethod = async (url: string, token: string, data: any = {}, extraHeaders: any = {}) => {
    // Track API call - this prevents inactivity timer from resetting
    trackApiCall();
    try {
      const response = await baseAxiosWithToken(token).post(url, data, { headers: extraHeaders });
      if(response?.data?.response?.success === false){
        console.log("server error:", response?.data?.response?.error);
        //throw new Error(response?.data?.response?.error);
        return response?.data;
      }
      return response.data;
    } catch (error) {
      // Optional: Extract more detailed server error message
      if (axios.isAxiosError(error)) {
        const message =
          error.response?.data?.message ||
          `Server responded with status ${error.response?.status}` ||
          'Unknown error';
        throw new Error(message);
      }
      throw new Error("We’re having trouble connecting to the server. Please try again in a moment.");
    }
  };


export const postCommonApi = async (url: string, data: any) => {
  try {
    const response = await axios.post(url, data);
    if(response?.data?.response?.success === false){
      console.log("server error:", response?.data?.response?.error);
      throw new Error(response?.data?.response?.error);
    }
    return response.data;
  } catch (error) {
    throw new Error("We’re having trouble connecting to the server. Please try again in a moment.");
  }
};


export const getCommonApiWithoutToken = async(url: string) =>{

  try{

    const responGet = await baseAxiosWithoutToken().get(url);
    if(responGet?.data?.response?.success === false){
      console.log("server error:", responGet?.data?.response?.error);
      throw new Error(responGet?.data?.response?.error);
    }
    return responGet.data;

  }catch(error){
    throw new Error("We’re having trouble connecting to the server. Please try again in a moment.");
  }

}